export const RESERVATION_VARIANT = {
  SINGLESTEP: "SINGLESTEP",
  MULTISTEP: "MULTISTEP",
  MULTISTEP_ANCILLARIES: "MULTISTEP_ANCILLARIES",
}
